import { MatrixCareCensusDto, MatrixCareCensusGroupDto, MatrixCarePatientCensusFilterDto } from '@medone/medonehp-api-client';

export interface MatrixCareCensusState {
    loading: boolean;
    processing: boolean;
    errorMessage: string;
    census: MatrixCareCensusGroupDto;
    currentCensus?: MatrixCareCensusDto;
    censusFilters: MatrixCarePatientCensusFilterDto;
}

export const initialState: MatrixCareCensusState = {
    loading: true,
    processing: false,
    errorMessage: null,
    census: null,
    currentCensus: null,
    censusFilters: null,
};
